import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// English translations
import enRegistration from './locales/en/registration.json';
import enNavbar from './locales/en/navbar.json';
import enCommon from './locales/en/common.json';
import enLogin from './locales/en/login.json';
import enHero from './locales/en/hero.json';
import enFeatures from './locales/en/features.json';
import enWorkflow from './locales/en/workflow.json';
import enGallery from './locales/en/gallery.json';
import enTestimonials from './locales/en/testimonials.json';
import enPricing from './locales/en/pricing.json';
import enFaq from './locales/en/faq.json';
import enCta from './locales/en/cta.json';
import enFooter from './locales/en/footer.json';
import enDashboard from './locales/en/dashboard.json';
import enCard from './locales/en/card.json';
import enVideoViewer from './locales/en/videoviewer.json';
import enUpload from './locales/en/upload.json';
import enCost from './locales/en/cost.json';
import enInvoice from './locales/en/invoice.json';
import enTerms from './locales/en/terms.json';
import enPayment from './locales/en/payment.json';
import enGuide from './locales/en/guide.json';
import enProfile from './locales/en/profile.json';
import enUserUploads from './locales/en/userUploads.json';
import enInvoiceForm from './locales/en/invoiceForm.json';
import enCookies from './locales/en/cookies.json';
import enPromptEditor from './locales/en/promptEditor.json';
import enVerification from './locales/en/verification.json';
import enForgotPassword from './locales/en/forgotPassword.json';
import enResetPassword from './locales/en/resetPassword.json';

// Resources object with translations
const resources = {
  en: {
    registration: enRegistration,
    navbar: enNavbar,
    common: enCommon,
    login: enLogin,
    hero: enHero,
    features: enFeatures,
    workflow: enWorkflow,
    gallery: enGallery,
    testimonials: enTestimonials,
    pricing: enPricing,
    faq: enFaq,
    cta: enCta,
    footer: enFooter,
    dashboard: enDashboard,
    card: enCard,
    videoviewer: enVideoViewer,
    upload: enUpload,
    cost: enCost,
    invoice: enInvoice,
    terms: enTerms,
    payment: enPayment,
    guide: enGuide,
    profile: enProfile,
    userUploads: enUserUploads,
    invoiceForm: enInvoiceForm,
    cookies: enCookies,
    promptEditor: enPromptEditor,
    verification: enVerification,
    forgotPassword: enForgotPassword,
    resetPassword: enResetPassword
  }
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    
    ns: [
      'common',
      'registration',
      'navbar',
      'login',
      'hero',
      'features',
      'workflow',
      'gallery',
      'testimonials',
      'pricing',
      'faq',
      'cta',
      'footer',
      'dashboard',
      'card',
      'videoviewer',
      'upload',
      'cost',
      'invoice',
      'terms',
      'payment',
      'guide',
      'profile',
      'userUploads',
      'invoiceForm',
      'cookies',
      'promptEditor',
      'verification',
      'forgotPassword',
      'resetPassword'
    ],
    defaultNS: 'common',
    
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;